module.exports = __webpack_public_path__ + "img/icon.fa0022b8.svg";